import React, {Component} from 'react';
import {connect} from 'react-redux';
import {DropdownList} from 'react-widgets';
import {Modal} from 'react-bootstrap';

import actions from './../../actions';
import {entityFetcher} from './../../utils/entityFetcher';
import {getUserProperty} from './../../utils/userProfile';
import {getMessage, getUsedLanguage, getSupportedLanguages} from './../../utils/i18n';

class ChangeLanguage extends Component {

    constructor(props) {
        super(props);
        const originalValue = getUsedLanguage();
        this.pendingRequests = {};
        this.state = {
            data: (() => {
                let languages = getSupportedLanguages();
                return Object.keys(languages).map((key) => ({text: languages[key].displayLabel, value: key}));
            })(),
            originalValue: originalValue,
            value: originalValue,
            disabled: false
        };
        this.onChange = this.onChange.bind(this);
        this.updateUserLanguage = this.updateUserLanguage.bind(this);
        this.onHideModal = this.onHideModal.bind(this);
        this.registerRequest = this.registerRequest.bind(this);
    };

    onChange(option) {
        this.setState({value: option.value});
    };

    getUserEntity() {
        const requestToken = new Date().getTime();
        return entityFetcher.read({
            api: `fo/me/profile`,
            cancelToken: this.registerRequest(requestToken)
        }).then(json => {
            delete this.pendingRequests[requestToken];
            return json;
        }, e => {
            delete this.pendingRequests[requestToken];
            return Promise.reject(e);
        });
    };

    updateUserLanguage() {
        const id = getUserProperty('id'), requestToken = new Date().getTime();
        this.setState({disabled: true});
        this.getUserEntity().then(user => {
            return entityFetcher.update({
                api: `fo/me/profile`,
                cancelToken: this.registerRequest(requestToken),
                data: {id, entityType: 'user', ...(user || {}), language: this.state.value}
            }).then(() => {
                this.setState({disabled: false});
                delete this.pendingRequests[requestToken];
                this.onHideModal();
                this.props.initialize();
            });
        }).catch(() => {
            this.setState({disabled: false});
            delete this.pendingRequests[requestToken];
        });
    };

    onHideModal() {
        !this.state.disabled && this.props.history.goBack();
    };

    registerRequest(token) {
        token = token ? token : new Date().getTime();
        return (cancelFunc) => {
            Object.assign(this.pendingRequests, {[token]: cancelFunc});
        };
    };

    componentWillUnmount() {
        Object.keys(this.pendingRequests).forEach((token) => {
            this.pendingRequests[token]();
            delete this.pendingRequests[token];
        });
    };

    render() {
        const {data, originalValue, value, disabled} = this.state;
        return (
            <Modal backdrop="static" show={true} onHide={this.onHideModal} id="changeLanguageModal">
                <Modal.Header closeButton={!disabled}>
                    <Modal.Title>{getMessage('app.action.change-language')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="foLanguageSelector">
                        <DropdownList
                            textField={'text'}
                            valueField={'value'}
                            data={data}
                            value={value}
                            onChange={this.onChange}
                            messages={{
                                openDropdown: getMessage("app.placeholder.open-dropdown")
                            }}
                            {...(disabled ? {disabled: true, busy: true} : {})}/>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="foPrimaryButton"
                            onClick={this.updateUserLanguage}
                            {...(disabled || originalValue === value ? {disabled: 'disabled'} : {})}>{getMessage("app.action.submit")}</button>
                    <button className="foNormalButton"
                            onClick={this.onHideModal}
                            {...(disabled ? {disabled: 'disabled'} : {})}>{getMessage("app.action.cancel")}</button>
                </Modal.Footer>
            </Modal>
        );
    };

}

export default connect(null, {
    initialize: actions.initialize,
})(ChangeLanguage);


// WEBPACK FOOTER //
// ./src/app/containers/changeLanguage/index.js